import React from 'react';

export type QuickActionProps = {
  title: string;
  icon: React.ReactNode;
  color: string; // e.g. "bg-pink-200 text-pink-700"
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
};

const QuickAction: React.FC<QuickActionProps> = ({
  title,
  icon,
  color,
  onClick,
  disabled,
  className = '',
}) => {
  return (
    <button
      disabled={disabled}
      className={`
        rounded-lg p-8 flex flex-col items-center justify-center
        text-center font-semibold text-[#2B1C25] transition-all
        ${color}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:brightness-95'}
        ${className}
      `}
      onClick={onClick}
    >
      <div className="text-2xl">{icon}</div>
      <span className="mt-2 text-sm">{title}</span>
    </button>
  );
};

export default QuickAction;
